import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { useEffect } from "react";

const useFetchAllPagesForInfiniteQuery = (query: UseInfiniteQueryResult) => {
  useEffect(() => {
    if (query.isFetchingNextPage || !query.hasNextPage) {
      return;
    }
    query.fetchNextPage();
  }, [query]);
};

export default useFetchAllPagesForInfiniteQuery;
